'use client';

import { useState, useEffect, useCallback } from 'react';
import { clientDownloadsApi } from '../api';
import type { ApplicationDownload } from '../types';

interface UseDownloadsReturn {
  downloads: ApplicationDownload[];
  isLoading: boolean;
  error: Error | null;
  refetch: () => Promise<void>;
}

export function useDownloads(): UseDownloadsReturn {
  const [downloads, setDownloads] = useState<ApplicationDownload[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchDownloads = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await clientDownloadsApi.getDownloads();
      if (response.success && response.data) {
        setDownloads(response.data);
      } else {
        throw new Error('Failed to retrieve downloads list');
      }
    } catch (err: any) {
      setError(err instanceof Error ? err : new Error(err?.message || 'Failed to fetch downloads'));
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDownloads();
  }, [fetchDownloads]);

  return {
    downloads,
    isLoading,
    error,
    refetch: fetchDownloads
  };
}
